import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InternalRouter as Router } from '../router/internal-router.service';
import { WpTokenService } from './wp-token.service';
import { environment } from '../../../environments/environment';

import { BaseComponents } from '../../base.component';

@Injectable()
export class StoreSubStateGuard extends BaseComponents  {

  constructor(
    protected injectorObj:Injector,
    private router: Router,
    private route: ActivatedRoute,
    private verifyWpTokenService: WpTokenService
  ) { 
    super(injectorObj);
  }

  canActivate(): boolean {

    this.route.queryParams.subscribe(params => {
      // console.log('params', params);
      // let paramsTmp = { ...params };
      let sub_state = params['sub_state'];
      if( sub_state == ''){
        localStorage.removeItem('sub_state');
      } else if (sub_state){
        localStorage.setItem('sub_state', sub_state);
      }
    });
    return true;
  }
}
